import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ViewMode = 'grid' | 'list';
export type TabValue = 'highlights' | 'assessment' | 'details' | 'documents';

interface EditCategoryModalState {
  open: boolean;
  documentId: string | null;
  documentName: string;
  documentCategory: string;
  selectedDocumentType: string;
  selectedCategoryName: string;
}

interface LoanDetailState {
  activeTab: TabValue;
  viewMode: ViewMode;
  searchText: string;
  selectedDocuments: string[];
  editCategoryModal: EditCategoryModalState;
}

const initialState: LoanDetailState = {
  activeTab: 'documents',
  viewMode: 'grid',
  searchText: '',
  selectedDocuments: [],
  editCategoryModal: {
    open: false,
    documentId: null,
    documentName: '',
    documentCategory: '',
    selectedDocumentType: '',
    selectedCategoryName: '',
  },
};

const loanDetailSlice = createSlice({
  name: 'loanDetail',
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<TabValue>) => {
      state.activeTab = action.payload;
    },
    setViewMode: (state, action: PayloadAction<ViewMode>) => {
      state.viewMode = action.payload;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setSelectedDocuments: (state, action: PayloadAction<string[]>) => {
      state.selectedDocuments = action.payload;
    },
    toggleDocumentSelection: (state, action: PayloadAction<string>) => {
      const docId = action.payload;
      const index = state.selectedDocuments.indexOf(docId);
      if (index > -1) {
        state.selectedDocuments.splice(index, 1);
      } else {
        state.selectedDocuments.push(docId);
      }
    },
    clearSelection: (state) => {
      state.selectedDocuments = [];
    },
    openEditCategoryModal: (
      state,
      action: PayloadAction<{
        documentId: string;
        documentName: string;
        documentCategory: string;
        documentType: string;
      }>
    ) => {
      state.editCategoryModal = {
        open: true,
        documentId: action.payload.documentId,
        documentName: action.payload.documentName,
        documentCategory: action.payload.documentCategory,
        selectedDocumentType: action.payload.documentType,
        selectedCategoryName: action.payload.documentCategory,
      };
    },
    closeEditCategoryModal: (state) => {
      state.editCategoryModal = {
        open: false,
        documentId: null,
        documentName: '',
        documentCategory: '',
        selectedDocumentType: '',
        selectedCategoryName: '',
      };
    },
    setEditCategoryDocumentType: (state, action: PayloadAction<string>) => {
      state.editCategoryModal.selectedDocumentType = action.payload;
    },
    setEditCategoryCategoryName: (state, action: PayloadAction<string>) => {
      state.editCategoryModal.selectedCategoryName = action.payload;
    },
  },
});

export const {
  setActiveTab,
  setViewMode,
  setSearchText,
  setSelectedDocuments,
  toggleDocumentSelection,
  clearSelection,
  openEditCategoryModal,
  closeEditCategoryModal,
  setEditCategoryDocumentType,
  setEditCategoryCategoryName,
} = loanDetailSlice.actions;
export default loanDetailSlice.reducer;
